import React from 'react';
import { useState, useEffect } from 'react';

import RoleForm from './RoleForm';
import { loadRolesConfig, loadRole, loadCompany } from './services';

export default function ViewRole({ match, history, updateBreadcrumbs }) {
    const { id, company_id: companyId } = match.params;
    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState(null);

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'View Role',
            ])
        );
        let loaded = 0;
        loadRolesConfig().then(config => {
            setRoles(config);
            loaded += 1;
            if (loaded === 2) {
                setLoaded(true);
            }
        });
        loadRole(id, companyId).then(data => {
            setRole(data);
            loaded += 1;
            if (loaded === 2) {
                setLoaded(true);
            }
        });
    }, []);

    const handleClone = () =>
        history.push(`/companies/${companyId}/partner/roles/clone/${id}`);
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/roles`);
    if (!loaded) {
        return null;
    }
    return (
        <RoleForm
            mode="view"
            role={role}
            roles={roles}
            onClone={handleClone}
            onCancel={handleCancel}
        />
    );
}
